<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ItineraryTextTypes from '../../variables/itineraryTextTypes';
import TwWysiwyg from '../TwWysiwyg';

export default {
  name: 'ItineraryMatrixTexts',
  components: {
    TwWysiwyg,
  },
  data() {
    return {
      ItineraryTextTypes,
      toggled: false,
    };
  },
  created() {
    this.getItineraryTexts({
      itineraryId: this.$route.params.id,
      domainId: this.$route.params.domainId,
    });
  },
  computed: {
    ...mapState({
      itineraryTexts: state => state.itinerary.itineraryTexts,
    }),
    ...mapGetters({
      mainItineraryText: 'itinerary/mainItineraryText',
      generalItineraryTexts: 'itinerary/generalItineraryTexts',
      importantItineraryTexts: 'itinerary/importantItineraryTexts',
    }),
  },
  methods: {
    ...mapActions({
      getItineraryTexts: 'itinerary/getItineraryTexts',
      saveItineraryTexts: 'itinerary/saveItineraryTexts',
      updateItineraryText: 'itinerary/updateItineraryText',
      addItineraryText: 'itinerary/addItineraryText',
    }),
  },
};
</script>

<template>
  <div class="text-xs-center">
    <v-btn
      :loading="itineraryTexts.loading"
      :disabled="itineraryTexts.loading"
      color="primary"
      @click="toggled = true"
    >
      Matrix texts
    </v-btn>
    <v-dialog
      v-if="toggled"
      v-model="toggled"
      width="1500"
    >
      <v-card class="pa-4">
        <template v-if="!itineraryTexts.loading">
          <h1 class="mb-3">Main itinerary text</h1>
          <tw-wysiwyg
            :value="mainItineraryText.text"
            placeholder="Description"
            @change="updateItineraryText({
              text: mainItineraryText,
              value: $event
            })"
          />
          <v-divider class="divider"/>
          <div class="d-flex gap-3">
            <div>
              <h1 class="mb-3">General itinerary texts</h1>
              <div
                v-for="(generalItineraryText, generalItineraryTextIndex) in generalItineraryTexts"
                :key="`general-texts-${generalItineraryTextIndex}`"
              >
                <tw-wysiwyg
                  :value="generalItineraryText.text"
                  @change="updateItineraryText({
                    index: generalItineraryTextIndex,
                    text: generalItineraryText,
                    value: $event
                  })"
                />
                <v-divider class="divider"/>
              </div>
              <div class="d-flex">
                <v-btn color="primary" @click="addItineraryText(ItineraryTextTypes.GENERAL)">
                  Add new text
                </v-btn>
              </div>
            </div>
            <div>
              <h1 class="mb-3">Important itinerary texts</h1>
              <div
                v-for="(importantItineraryText, importantItineraryTextIndex) in importantItineraryTexts"
                :key="`general-texts-${importantItineraryTextIndex}`"
              >
                <tw-wysiwyg
                  :value="importantItineraryText.text"
                  @change="updateItineraryText({
                    index: importantItineraryTextIndex,
                    text: importantItineraryText,
                    value: $event
                  })"
                />
                <v-divider class="divider"/>
              </div>
              <div class="d-flex">
                <v-btn color="primary" @click="addItineraryText(ItineraryTextTypes.IMPORTANT)">
                  Add new text
                </v-btn>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <v-btn color="success" @click="saveItineraryTexts({
              itineraryId: $route.params.id,
              domainId: $route.params.domainId,
            })">
              Save texts
            </v-btn>
          </div>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryMatrixTexts.vue